

import axios from "axios";
import { toast } from "react-hot-toast";

// Action types
export const EMPLOYEE_LOGIN_REQUEST = "EMPLOYEE_LOGIN_REQUEST";
export const EMPLOYEE_LOGIN_SUCCESS = "EMPLOYEE_LOGIN_SUCCESS";
export const EMPLOYEE_LOGIN_FAILURE = "EMPLOYEE_LOGIN_FAILURE";
export const EMPLOYEE_LOGOUT = "EMPLOYEE_LOGOUT";

// Base API URL from environment
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Login Action
export const loginEmployee = (credentials) => async (dispatch) => {
  dispatch({ type: EMPLOYEE_LOGIN_REQUEST });

  try {
    const res = await axios.post(
      `${BASE_URL}/api/login`,
      credentials,
      { headers: { "Content-Type": "application/json" } }
    );

    const { data, meta } = res.data;

    if (meta?.status) {
      // Store in localStorage
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("user", JSON.stringify(data));

      dispatch({ type: EMPLOYEE_LOGIN_SUCCESS, payload: data });
      toast.success(meta.message || "Login successful");
    } else {
      dispatch({ type: EMPLOYEE_LOGIN_FAILURE, payload: meta.message });
      toast.error(meta.message || "Login failed");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: EMPLOYEE_LOGIN_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};

// // Logout Action
// export const logoutEmployee = () => (dispatch) => {
//   localStorage.removeItem("token");
//   localStorage.removeItem("user");
//     localStorage.removeItem("surveyType");
//       localStorage.removeItem("selectedCanteen");
//         localStorage.removeItem("surveyData");
//           localStorage.removeItem("completedSections");

//   dispatch({ type: EMPLOYEE_LOGOUT });
//   toast.success("Logged out successfully");
// };
// Logout Action
export const logoutEmployee = () => (dispatch) => {
  // Comprehensive localStorage cleanup
  const allKeys = [
    "token",
    "user",
    "surveyType",
    "selectedCanteen",
    "selectedSurvey",
    "surveyData",
    "completedSections",
    "surveyId",
    "currentSurveySection",
    "surveyProgress",
    "tempSurveyData"
  ];
  
  allKeys.forEach(key => localStorage.removeItem(key));
  
  // Also clear any keys that start with survey or form
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('survey') || key.includes('form') || key.includes('draft'))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  // Clear session storage
  sessionStorage.clear();
  
  dispatch({ type: EMPLOYEE_LOGOUT });
  
  // Show success message
  toast.success("Logged out successfully");
};